import { AssetDownloadItemDto, AssetItemDto } from '@api/Api';
import { nonNull } from '@helpers/non-null';

export function download(
  url: URL | string | null | undefined,
  fileName?: string | undefined
) {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url.toString();
  link.download = fileName ?? '';
  link.target = '_blank';
  link.click();
  link.remove();
}

export function downloadImage(
  url: URL | string | null | undefined,
  fileName?: string | undefined
) {
  if (!url) return;
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName ?? '';
      link.click();
      URL.revokeObjectURL(link.href);
    });
}

export function downloadAll(
  files: Array<
    URL | string | AssetItemDto | AssetDownloadItemDto | null | undefined
  >,
  fileName?: string,
  parentId?: string
) {
  const assets = files
    .map((x) => {
      if (!x) return null;
      if (typeof x === 'string') return { url: new URL(x), path: [] };
      if (x instanceof URL) return { url: x, path: [] };
      if ('sourceUrl' in x && x.sourceUrl) {
        return { url: new URL(x.sourceUrl), path: x.path.map((p) => p.name) };
      }
      if ('asset' in x && x.asset) {
        const version = x.asset.versions[0];
        if (!version.sourceUrl) return null;
        let { path } = x;
        if (parentId) {
          const parentIndex = path.findIndex((p) => p.id === parentId);
          if (parentIndex >= 0) {
            path = path.slice(parentIndex + 1);
          }
        }
        return {
          url: new URL(version.sourceUrl),
          path: path.map((p) => p.name)
        };
      }
      return null;
    })
    .filter((x) => !!x)
    .map((x) => nonNull(x));

  // using service-worker to merge all files into zip archive
  const form = document.createElement('form');
  form.method = 'GET';
  form.action = `/download-all/${fileName ?? 'files.zip'}`;
  form.style.display = 'none';
  const input = document.createElement('input');
  input.name = 'assets';
  input.value = JSON.stringify(assets);
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
  form.remove();
}
